<epc-dynamic-collections-renderer
  [isRoot]="true"
  [scope]="this"
  [items]="itemsArray"
  class="d-contents"
>
</epc-dynamic-collections-renderer>
